export const isEnableRudderStack = () => Boolean(window.rudderanalytics)

export function logRudderEvent(event, data) {
  if (
    process.env.NODE_ENV !== 'production' &&
    process.env.NODE_ENV !== 'test'
  ) {
    console.log('🦆Rudder:', event, data || '') // eslint-disable-line no-console
  }
}

export function rudderGetUserTraits() {
  if (window.rudderanalytics.getUserTraits) {
    return window.rudderanalytics?.getUserTraits()
  }

  return null
}

export async function rudderTrackAction(eventName, parsedData, contextData) {
  const rawCampaign = sessionStorage.getItem('campaign_data')
  const campaignData = rawCampaign
    ? (() => {
        try {
          return JSON.parse(rawCampaign)
        } catch {
          return {}
        }
      })()
    : {}

  window.rudderanalytics.track(
    eventName,
    { ...parsedData, ...campaignData },
    {
      context: { traits: contextData },
    },
  )

  window.postMessage(
    { type: 'RUDDER_UPDATE', eventName },
    window.location.origin,
  )

  logRudderEvent(eventName, { ...parsedData, ...campaignData })
}

export async function rudderIdentifyUser(idCustomer, data) {
  window.rudderanalytics.identify(idCustomer, {
    ...data,
  })
  logRudderEvent('identify', data)
}

export function rudderIdentifyGuestMode(anonymousID = null) {
  if (anonymousID) {
    window.rudderanalytics.setAnonymousId(anonymousID)
  }
  window.rudderanalytics.identify()
  logRudderEvent('identify')
}

export async function rudderReset() {
  window.rudderanalytics.reset()
  logRudderEvent('reset')
}
